import { CheckCircle2 as ShoppingCartCheckout, ShoppingCart } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormatPrice from "../../../../components/FormatPrice";
import { useCart } from "../../../../context/CartContext";
import { useDomain } from "../../../../context/DomainContext";
import { addProductToCart } from "../../../products/ProductToCart";
import { useDispatch } from "react-redux";
import { setSelectedProduct } from "../../../../api/reducers/selectedProductReducer";
import RetailRichTextDescription from "../../RetailRichTextDescription";

const ProductsList = ({ products, loggedIn }) => {
  const productsPerPage = 15;
  const currentProducts = products.slice(0, productsPerPage);

  return (
    <div className="p-4">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
        {currentProducts.length > 0 ? (
          currentProducts.map((item) => (
            <ProductItem key={item._id} productItem={item} loggedIn={loggedIn} />
          ))
        ) : (
          <div className="col-span-full">
            <div className="animate-pulse bg-gray-200 h-48 rounded-md"></div>
          </div>
        )}
      </div>
    </div>
  );
};

const ProductItem = ({ productItem }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const domain = useDomain();
  const { addToCart, updateCart } = useCart();
  const [addedToCart, setAddedToCart] = useState(false);

  const viewProductDetail = (product) => {
    dispatch(setSelectedProduct(product));
    navigate("/tf/product-info");
  };

  const handleProductClick = (product) => {
    if (domain === "RETAIL") {
      viewProductDetail(product);
    }
  };

  const handleAddToCart = (product) => {
    addProductToCart({
      addToCart,
      navigate,
      productDetails: product,
      quantity: 1,
      updateCart,
    });

    const storedCart = JSON.parse(localStorage.getItem("cartProducts")) || [];
    const existingProduct = storedCart.find((item) => item._id === product._id);

    if (existingProduct) {
      const updatedCart = storedCart.map((item) =>
        item._id === product._id ? { ...item, quantity: item.quantity + 1 } : item
      );
      localStorage.setItem("cartProducts", JSON.stringify(updatedCart));
      // dispatch(setCartProducts(updatedCart));
    } else {
      const updatedCart = [...storedCart, { ...product, quantity: 1 }];
      localStorage.setItem("cartProducts", JSON.stringify(updatedCart));
      // dispatch(setCartProducts(updatedCart));
    }

    setAddedToCart(true);
  };

  const handleGoToCart = () => {
    navigate("/cart");
  };

  const [currentImage, setCurrentImage] = useState(
    productItem.imageURL || (productItem.imageUrlsList && productItem.imageUrlsList[0]) || ""
  );

  const handleMouseEnter = () => {
    if (productItem.imageUrlsList && productItem.imageUrlsList.length > 1) {
      setCurrentImage(productItem.imageUrlsList[1]);
    }
  };

  const handleMouseLeave = () => {
    setCurrentImage(
      productItem.imageURL || (productItem.imageUrlsList && productItem.imageUrlsList[0]) || ""
    );
  };

  return (
    <div
      className="flex flex-col rounded-lg border border-teal-300 overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer mt-8"
      onClick={() => handleProductClick(productItem)}
    >
      <div className="w-full max-w-[300px] max-h-[400px] aspect-w-1 aspect-h-1">
        <img
          loading="lazy"
          src={currentImage}
          alt={productItem.name}
          className="w-full h-full object-cover"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>

      <div className="p-3 flex flex-col justify-between flex-1">
        <h2 className="text-teal-700 hover:text-teal-500 text-lg font-medium">
          {productItem.name}
        </h2>

        <p className="mt-1 font-bold text-teal-600">
          {productItem.price && (
            <FormatPrice
              code={productItem.price.currency || "USD"}
              price={productItem.price.priceAmt}
            />
          )}
        </p>
        <RetailRichTextDescription content={productItem.description} className="mt-1" />

        <button
          className={`mt-2 py-2 px-4 rounded-full w-full text-white ${addedToCart ? "bg-teal-600" : "bg-teal-500"} 
            hover:bg-white hover:text-teal-500 border ${addedToCart ? "border-teal-600" : "border-teal-500"} 
            transition duration-300 text-sm md:text-base`}
          onClick={(e) => {
            e.stopPropagation();
            if (addedToCart) {
              handleGoToCart();
            } else {
              handleAddToCart(productItem);
            }
          }}
        >
          <span>{addedToCart ? "Go to Cart" : "Add to Cart"}</span>
          <span className="ml-2">
            {addedToCart ? <ShoppingCartCheckout /> : <ShoppingCart />}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProductsList;
